import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import {
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  IconButton,
  Snackbar,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function DocumentExport() {
  const [collectionName, setCollectionName] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [documentData, setDocumentData] = useState(null);
  const [error, setError] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleExport = async () => {
    if (!collectionName || !documentId) {
      setError('Please fill in both fields');
      return;
    }

    try {
      const docRef = doc(db, collectionName, documentId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setDocumentData(docSnap.data());
        setError('');
      } else {
        setError('Document not found');
        setDocumentData(null);
      }
    } catch (err) {
      setError('Error fetching document: ' + err.message);
      setDocumentData(null);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(documentData, null, 2));
    setSnackbarOpen(true);
  };

  return (
    <Box sx={{ maxWidth: 800, margin: '0 auto', p: 2 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Document Export
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
        <TextField
          label="Collection Name"
          value={collectionName}
          onChange={(e) => setCollectionName(e.target.value)}
          error={error && !collectionName}
          fullWidth
        />
        <TextField
          label="Document ID"
          value={documentId}
          onChange={(e) => setDocumentId(e.target.value)}
          error={error && !documentId}
          fullWidth
        />
        <Button 
          variant="contained" 
          onClick={handleExport}
          sx={{ minWidth: '120px' }}
        >
          Export
        </Button>
      </Box>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}

      {documentData && (
        <Paper 
          sx={{ 
            p: 2, 
            position: 'relative',
            backgroundColor: '#f5f5f5',
            '& pre': {
              margin: 0,
              overflow: 'auto',
              maxHeight: '500px'
            }
          }}
        >
            <IconButton
              onClick={handleCopy}
              sx={{
                position: 'absolute',
                width: 'auto',
                right: 8,
                top: 8
              }}
            >
            <ContentCopyIcon />
          </IconButton>
          <pre>
            {JSON.stringify(documentData, null, 2)}
          </pre>
        </Paper>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="JSON copied to clipboard"
      />
    </Box>
  );
}

export default DocumentExport;
